/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('hammerjs');
require('any-resize-event');
require('url-search-params-polyfill');
require('objectFitPolyfill');

window.PhotoSwipe = require('../../node_modules/photoswipe/dist/photoswipe');
window.PhotoSwipeUI_Default = require('../../node_modules/photoswipe/dist/photoswipe-ui-default');

import Vue from 'vue';
import Swiper from '../../node_modules/swiper/dist/js/swiper.js';
import ReadMore from './components/read-more';
import SubscriptionForm from './subscriptions';

window.Vue = Vue;
window.Vue.prototype.$http = require('axios');

Vue.directive('swipe', {
    bind: function(el, binding) {
        if(typeof binding.value === 'function') {
            const mc = new Hammer(el);
            mc.get('swipe').set({direction: Hammer.DIRECTION_HORIZONTAL});
            mc.on('swipe', binding.value);
        }
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('posts-count', require('./components/PostsCount.vue').default);
Vue.component('posts-search', require('./components/PostsSearch.vue').default);
Vue.component('posts-pagination', require('./components/PostsPagination.vue').default);
Vue.component('newsletter-signup', require('./components/NewsletterSignup.vue').default);
Vue.component('manage-newsletter-subscriptions', require('./components/ManageNewsletterSubscriptions.vue').default);
Vue.component('slider', require('./components/Slider.vue').default);
Vue.component('slide', require('./components/Slide.vue').default);
Vue.component('retail-locations-search', require('./components/RetailLocationsSearch').default);
Vue.component('issue-cover', require('./components/InteractiveIssueCover').default);
Vue.component('leaflet', require('./components/Leaflet.vue').default);
Vue.component('advertising-contacts', require('./components/AdvertisingContacts.vue').default);
Vue.component('advertising-documents', require('./components/AdvertisingDocuments.vue').default);
Vue.component('advertising-products', require('./components/AdvertisingProducts.vue').default);
Vue.component('advertising-rates', require('./components/AdvertisingRates.vue').default);
Vue.component('advertising-notes', require('./components/AdvertisingNotes.vue').default);
Vue.component('advertiser-agency-relations', require('./components/AdvertiserAgencyRelations.vue').default);
Vue.component('adsize-relations', require('./components/AdSizeRelations.vue').default);
Vue.component('product-relations', require('./components/ProductRelations.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
new Vue({
    el: '#app'
});

document.addEventListener('DOMContentLoaded', () => {

    let readMore = new ReadMore();
    if(window.innerWidth < 1024) {
        readMore.init();
    }

    // Get all "nav__burger" elements
    const $navBurgers = Array.prototype.slice.call(document.querySelectorAll('.nav__burger'), 0);

    // Check if there are any navbar burgers
    if($navBurgers.length > 0) {

        // Add a click event on each of them
        $navBurgers.forEach(el => {
            el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "nav__burger" and the "nav__menu"
                el.classList.toggle('nav__burger--active');
                $target.classList.toggle('nav__main--active');
                document.getElementById('nav').classList.toggle('nav--active');

            });
        });
    }

    const $navDropdowns = Array.prototype.slice.call(document.querySelectorAll('.nav__item--dropdown'), 0);

    if($navDropdowns.length > 0) {
        $navDropdowns.forEach(el => {
            el.addEventListener('click', () => {
                el.classList.toggle('nav__item--active');
            });
        });
    }

    let $type = document.getElementsByName('type')[0];
    let $categoryId = document.getElementsByName('category_id')[0];
    let $onlineExclusiveOption = document.querySelectorAll('select[name="category_id"] > option[value="4"]')[0];
    let $newOnlineExclusiveOption = document.createElement('option');
    $newOnlineExclusiveOption.value = '4';
    $newOnlineExclusiveOption.text = 'Online Exclusive';

    if($type && $onlineExclusiveOption) {

        if($type.value === 'BLOG') {
            $onlineExclusiveOption.remove();
        }

        $type.onchange = function() {
            if($type.value === 'BLOG') {
                $onlineExclusiveOption.remove();
            } else {
                $categoryId.appendChild($newOnlineExclusiveOption);
            }
        };
    }

    const $exploreMore = Array.prototype.slice.call(document.querySelectorAll('.js-explore-more'), 0);

    if($exploreMore.length > 0) {

        // Add a click event on each of them
        $exploreMore.forEach(el => {
            el.addEventListener('click', () => {

                var top = $('#explore-more').offset().top; //Getting Y of target element

                let duration = 350;

                $('html, body').animate({
                    scrollTop: (top - 120)
                }, duration);

            });
        });
    }

    function windowPopup(url, width, height) {
        // Calculate the position of the popup so it’s centered on the screen.
        let left = (screen.width / 2) - (width / 2),
            top = (screen.height / 2) - (height / 2);

        window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
    }

    let $jsSocialShares = document.querySelectorAll('.js-social-share');
    if($jsSocialShares) {
        [].forEach.call($jsSocialShares, function(anchor) {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                windowPopup(this.href, 500, 300);
            });
        });
    }

    let $searchButton = document.getElementById('search-button');

    if($searchButton) {
        $searchButton.addEventListener('click', () => {

            const target = $searchButton.dataset.target;
            const $target = document.getElementById(target);

            // Toggle the "is-active" class on both the "nav__burger" and the "nav__menu"
            $target.classList.toggle('nav__search--active');

            let $input = document.querySelector('input[name="q"]');
            $input.focus();
        });
    }

    new Swiper('.swiper-container', {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 3,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
            slideShadows: false,
            rotate: 0,
            stretch: 60,
            depth: 200,
            modifier: 1
        },
        navigation: {
            nextEl: '.issues__button-next',
            prevEl: '.issues__button-prev'
        },
        breakpoints: {
            1023: {
                slidesPerView: 1
            }
        }
    });

    function setProgressBarMax() {
        let winHeight = $(window).height();
        let docHeight = $(document).height();
        let progressBar = $('progress');
        let max;
        let value;

        /* Set the max scrollable area */
        max = docHeight - winHeight;
        progressBar.attr('max', max);

        $(document).on('scroll', function() {
            value = $(window).scrollTop();
            progressBar.attr('value', value);
        });
    }

    setProgressBarMax();

    var $nav = document.getElementById('nav');
    var $navSecondary = document.getElementById('nav-secondary');
    var windowHeight = window.innerHeight - 120;

    if($nav && $navSecondary) {
        window.onscroll = function() {
            if(document.body.scrollTop > windowHeight || document.documentElement.scrollTop > windowHeight) {
                document.getElementById('nav').classList.remove('nav--full');
            } else {
                document.getElementById('nav').classList.add('nav--full');
            }
        };
    }

    window.onresize = function() {
        setProgressBarMax();
        windowHeight = window.innerHeight - 120;
        if(window.innerWidth < 1024) {
            readMore.init();
        } else {
            readMore.reset();
        }
    };

    if(typeof CountryArray !== 'undefined') {
        let subscriptionForm = new SubscriptionForm(CountryArray, PublisherDefaultCountry, CountryRegionArray, PublisherDefaultRegion, CountryAllowOtherRegionArray);
        subscriptionForm.init();
    }
});
